<script setup lang="ts">
import { usePublicFlowAdapter } from '../adapter.ts';

const adapter = usePublicFlowAdapter();
</script>

<template>
    <div class="text-sm text-center stack gap-xs">
        <p>
            Signed in as <strong>{{ adapter.actorEmail.value }}</strong>
        </p>
        <p>
            Not you?
            <button type="button" class="link" @click="adapter.logout()">Sign Out</button>
        </p>
    </div>
</template>
